import { useState } from "react";
import { Button } from "@dfws/ui";
import { useSaveVacation, useVacation, type Vacation } from "../../lib/queries";
import { ApiFailure } from "../../lib/api";
import { useSession } from "../../lib/queries";
import { Notice } from "./parts";
import s from "./Settings.module.css";

export function VacationSection() {
  const remote = useVacation();
  if (!remote.data) return <p className={s.muted}>Loading...</p>;
  return <VacationForm initial={remote.data} />;
}

function VacationForm({ initial }: { initial: Vacation }) {
  const save = useSaveVacation();
  const domain = useSession().data?.user.email.split("@")[1] ?? "your domain";
  const [v, setV] = useState<Vacation>(initial);
  const [saved, setSaved] = useState(false);

  const set = <K extends keyof Vacation>(k: K, val: Vacation[K]) => {
    setSaved(false);
    setV({ ...v, [k]: val });
  };
  async function onSave() {
    try {
      const r = await save.mutateAsync(v);
      setSaved(!r.warning);
    } catch {
      /* shown below */
    }
  }

  return (
    <>
      <p className={s.lead}>An automatic reply to people who write while you are away. Each sender gets it at most once a day, and mailing lists and automated mail never get it.</p>
      <div className={s.stack}>
        <label className={s.check} style={{ fontWeight: 600 }}>
          <input type="checkbox" role="switch" className={s.switch} checked={v.enabled} onChange={(e) => set("enabled", e.target.checked)} />
          Out of office reply {v.enabled ? "on" : "off"}
        </label>
        <div className={s.grid2}>
          <label className={s.field}><span>First day</span><input className={s.input} type="date" value={v.startDate ?? ""} onChange={(e) => set("startDate", e.target.value || null)} /></label>
          <label className={s.field}><span>Last day <small>(optional)</small></span><input className={s.input} type="date" value={v.endDate ?? ""} onChange={(e) => set("endDate", e.target.value || null)} /></label>
        </div>
        <label className={s.field}><span>Subject</span><input className={s.input} value={v.subject} onChange={(e) => set("subject", e.target.value)} placeholder="Out of office" /></label>
        <label className={s.field}><span>Message</span><textarea className={s.textarea} value={v.body} onChange={(e) => set("body", e.target.value)} placeholder="Thank you for your message. I am away until Monday and will reply when I am back." dir="auto" /></label>
        <label className={s.check}><input type="checkbox" checked={v.onlyDomain} onChange={(e) => set("onlyDomain", e.target.checked)} /> Only reply to people at {domain}</label>
        {save.error instanceof ApiFailure && <Notice kind="err">{save.error.message}</Notice>}
        {save.data?.warning && <Notice kind="warn">{save.data.warning}</Notice>}
        {saved && <Notice kind="ok">Saved. {v.enabled ? "The reply is active on the mail server." : "The reply is off."}</Notice>}
        <div className={s.actionsBar}>
          <Button variant="primary" onClick={onSave} loading={save.isPending}>Save changes</Button>
        </div>
      </div>
    </>
  );
}
